/* eslint-disable no-restricted-globals */
import buyflowGoto, { linkTo as buyflowLinkTo } from "./buyflow";
import purchaseGoto, { linkTo as purchaseLinkTo } from "./purchase";
import offersGoto, { linkTo as offersLinkTo } from "./offers";
import enrollmentGoto, { linkTo as enrollmentLinkTo } from "./enrollment";
import referralGoto from "./referral";
import pageSetGoto from "./page-set";
import { FetchInAppServerContextError } from "src/utils/context";
import { captureException } from "src/utils/sentry";
import { push } from "./utils";

export const linkTo = {
  ...buyflowLinkTo,
  ...purchaseLinkTo,
  ...offersLinkTo,
  ...enrollmentLinkTo,
};

export default {
  ...pageSetGoto,
  ...buyflowGoto,
  ...purchaseGoto,
  ...offersGoto,
  ...enrollmentGoto,
  ...referralGoto,

  currentSurvey(questionId: string, currentQuestionId = "") {
    // WARN: We assume hash router for all surveys at this point.
    const url = new URL(location.href);
    const pathSansTailingSlash = url.hash.replace(/\/$/, "");
    // istanbul ignore if : sanity
    if (!pathSansTailingSlash.endsWith(currentQuestionId)) {
      throw new Error(
        `Unexpected survey path: ${pathSansTailingSlash} expected ${currentQuestionId}`
      );
    }

    const surveyPath = currentQuestionId
      ? pathSansTailingSlash.slice(0, -currentQuestionId.length - 1)
      : pathSansTailingSlash;
    url.hash = `${surveyPath}/${questionId}`;
    push(`${url}`);
  },

  error(err?: Error, fingerprint?: string) {
    if (err) {
      // Use react error view in development
      if (__NODE_ENV__ !== "production") {
        throw err;
      } else {
        captureException(err, fingerprint);
      }
    }

    const identificationError = err instanceof FetchInAppServerContextError;

    location.href = `/${
      identificationError ? "identification-" : ""
    }error.html${location.search}`;
  },
};
